import { render, staticRenderFns } from "./AutoMadConfig.vue?vue&type=template&id=620ba9c3&scoped=true"
import script from "./AutoMadConfig.vue?vue&type=script&lang=js"
export * from "./AutoMadConfig.vue?vue&type=script&lang=js"
import style1 from "../../components/style/chat-view.scss?vue&type=style&index=1&id=620ba9c3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ba9c3",
  null
  
)

export default component.exports